import { Box, InputAdornment, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DataTable from '../UIElements/DataTable';
import { useDispatch } from 'react-redux';
import { onlineUSers } from '../../features/dashboard/dashboardSlice';
import { SearchIcon } from '@heroicons/react/outline';

function OnlineUsers() {
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchParameters, setSearchParameters] = useState({
    search: '',
    pageNumber: 0,
    pageSize: 10,
  });
  async function getDetails(data) {
    try {
      setLoading(true);
      const response = await dispatch(onlineUSers(data)).unwrap();
      setData(response?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }
  const columns = [
    {
      field: 'sno',
      headerName: <div className='text-sm'>SNO</div>,
      width: 70,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className=' cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'instituteName',
      headerName: <div className='text-sm'>Institute Name</div>,
      width: 240,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className=' cursor-default text-[14px] truncate'>
          {param.value}
        </div>
      ),
    },
    {
      field: 'instituteType',
      headerName: <div className='text-sm'>Institute Type</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'userName',
      headerName: <div className='text-sm'>full Name</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'role',
      headerName: <div className='text-sm'>Role</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'designation',
      headerName: <div className='text-sm'>Designation</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'email',
      headerName: <div className='text-sm'>Email Id</div>,
      width: 200,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default truncate'>{param.value}</div>
      ),
    },
    {
      field: 'mobileNumber',
      headerName: <div className='text-sm'>Phone number</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'location',
      headerName: <div className='text-sm'>Location</div>,
      width: 200,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default truncate'>{param.value}</div>
      ),
    },
    {
      field: 'smsService',
      headerName: <div className='text-sm'>SMS Service</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>
          {param.value ? '✔️' : '✖️'}
        </div>
      ),
    },
    {
      field: 'mobileService',
      headerName: <div className='text-sm'>Mobile Service</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>
          {param.value ? '✔️' : '✖️'}
        </div>
      ),
    },
    {
      field: 'access',
      headerName: <div className='text-sm'>Access </div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>
          {param.value ? '✔️' : '✖️'}
        </div>
      ),
    },
  ];
  useEffect(() => {
    getDetails(searchParameters);
  }, [searchParameters]);
  return (
    <>
      <div className='flex justify-between items-center'>
        <Typography variant='h6' className='text-[#1976d2]'>
          {' '}
          List of the Online Users
        </Typography>
        <SearchField
          setSearchParameters={setSearchParameters}
          initialValue={searchParameters.search}
        />{' '}
      </div>{' '}
      <Box
        sx={{
          overflowX: 'scroll', // always show scrollbar
          whiteSpace: 'nowrap', // prevent wrapping
          '&::-webkit-scrollbar': {
            height: '4px', // customize scrollbar height
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
          },
        }}
      >
        <div style={{ minWidth: '1200px' }}>
          <DataTable
            rows={(data?.users || [])?.map((row, index) => ({
              sno:
                searchParameters.pageNumber * searchParameters.pageSize +
                index +
                1,
              ...row,
            }))}
            columns={columns}
            rowCount={data?.totalRecords || 0}
            paginationMode='server'
            page={searchParameters?.pageNumber}
            pageSize={searchParameters?.pageSize}
            loading={loading}
            hideColumnIcons={true}
            onPageChange={(e) => {
              setSearchParameters((prev) => ({
                ...prev,
                pageNumber: e?.page,
                pageSize: e?.pageSize,
              }));
            }}
          />
        </div>
      </Box>
    </>
  );
}
export default OnlineUsers;
import { useMemo } from 'react';
import { debounce } from 'lodash-es';

export const SearchField = ({
  setSearchParameters,
  initialValue = '',
  delay = 500,
  ...props
}) => {
  const [search, setSearch] = useState(initialValue);

  const debouncedUpdate = useMemo(
    () =>
      debounce((value) => {
        setSearchParameters((prev) => ({
          ...prev,
          search: value,
        }));
      }, delay),
    [setSearchParameters, delay],
  );

  useEffect(() => {
    setSearch(initialValue);
    return () => debouncedUpdate.cancel();
  }, [initialValue, debouncedUpdate]);

  return (
    <TextField
      className='w-[200px] md:w-[420px]'
      size='small'
      placeholder='Search by institute name , locations etc'
      {...props}
      value={search}
      onChange={(e) => {
        const value = e.target.value;

        // Immediate UI update
        setSearch(value);

        // Delayed parent state update
        debouncedUpdate(value);
      }}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position='end'>
              <SearchIcon className='size-5 text-gray-600' />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
